import {Component, Input, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {ModalService, PatientService, ValidateService} from '../../services';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {saveAs as importedSaveAs} from "file-saver";

@Component({
  selector: 'app-download-file-document',
  templateUrl: './download-file-document.component.html',
  styleUrls: ['./download-file-document.component.scss']
})
export class DownloadFileDocumentComponent implements OnInit {

  fileUrl;
  @Input() nameOfFile;

  constructor
  (
      private sanitizer: DomSanitizer,
      public router: Router,
      private translate: TranslateService,
      private patientService: PatientService,
      private modalService: ModalService,
      private validateService: ValidateService
  )
  { }

  ngOnInit() {

  }

  downloadFile(){
    this.getDataFromDocument();
  }


  getDataFromDocument(){
    this.patientService.getDocumentFromDocumentation(this.nameOfFile).subscribe(data => {


          let dataEntry = data.data;
          let preparedData = new Buffer(dataEntry, 'base64');
          const blob = new Blob([preparedData]);
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

             var a = document.createElement("a");
             a.href = URL.createObjectURL(blob);

             a.download = this.nameOfFile;
             document.body.appendChild(a);

             a.click();
             a.remove();


        },
            err => this.modalService.open(this.translate.instant('BACKEND.COULDNT-GET-DATA'))
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/download-file-document/download-file-document.component.ts